import { BACK_JSONTREE_QUESTION, JSON_FORM } from '#app/constants/forms.ts'
import { type State, type Action } from '#types/form/wizard.ts'

export function handleBackJsonTreeQuestion<T>(
	state: State<T>,
	action: Action<T>,
): State<T> {
	if (state.type !== JSON_FORM || action.type !== BACK_JSONTREE_QUESTION) {
		return state
	}

	let newStack = [...state.answeredQuestionsStack]
	const currentStackItem = newStack.find(
		item => item.id === state.currentQuestionTreeId,
	)

	if (currentStackItem && currentStackItem.answers.length > 0) {
		currentStackItem.answers.pop()
		currentStackItem.currentQuestionId = action.previousQuestionId
	}

	return {
		...state,
		currentQuestionId: action.previousQuestionId,
		answeredQuestionsStack: newStack,
	}
}
